import { StatusMemberRegisterWaiting } from 'app/api/event/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import {
  ILocation,
  ITeam,
} from 'app/containers/EventManagement/layouts/CreateEvent/type'
import { useChangeStatusMemberRegister } from 'app/react-query/hook/event'
import { useAppSelector } from 'app/redux/hooks'
import { useRef } from 'react'

export const ModalApproveMember = ({
  id,
  locations,
}: {
  id?: number
  listTeam?: ITeam[]
  locations?: ILocation[]
}) => {
  const user = useAppSelector(state => state?.user)?.profile
  const refModal = useRef<IRefModal>({})
  const [form] = BaseForm.useForm<{ team: number; locationIds?: number[] }>()
  const { mutateAsync: mutateAsyncUpdate, isLoading } =
    useChangeStatusMemberRegister()

  const handleSubmit = async () => {
    if (!id) return
    const res = await mutateAsyncUpdate({
      id,
      status: StatusMemberRegisterWaiting.ACCEPTED,
      approvedById: +(user?.member?.id ?? 0),
      locationIds: locations?.map(itm => itm?.id ?? 0),
    })

    if (res) {
      refModal?.current?.hide?.()
      window.location.reload()
    }
  }

  return (
    <BaseModalComponent
      ref={refModal}
      titleModal="Phê duyệt đăng ký"
      buttonOpenModal={
        <BaseButton
          children="Phê duyệt"
          onClick={() => refModal.current?.open?.()}
          type="text"
        />
      }
      handleSubmit={form?.submit}
      isLoadingConfirm={isLoading}
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <BaseSpace size={8}>
            <BaseText
              children={`Bạn có chắc chắn phê duyệt đơn đăng ký này?`}
              fontWeight="medium"
              fontSize="xs"
            />
            <BaseText
              children={`Lưu ý: Sau khi phê duyệt, bạn có thể thay đổi trạng thái của đoàn viên trong hoạt động`}
              colorText="statesOrangeColor"
              opacity="0.8"
            />
          </BaseSpace>
        </BaseForm>
      }
    />
  )
}
